import './App.sass';
import KeyMenu from 'comps/KeyMenu.js'
import {Row, Col} from 'react-bootstrap'
import {ReactComponent as LogoWs} from 'img/logo/ws-gruppen.svg'
import { Switch, Route } from 'react-router'
import WelcomePage from './App/WelcomePage.js'
import {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import actions from 'redux/actionsAndReducers/apiAccess_Actions.js'
import ApiPage from "App/ApiPage.js";
import { push } from 'connected-react-router'

const App = () => {
    const reduxDispatch = useDispatch()
    
        useEffect(()=>{
        reduxDispatch(actions.readApiAccess())
    }, [reduxDispatch])

    const reduxApiAccess = useSelector(store => store.apiAccess)
    const apiAccess = reduxApiAccess.value
    
    return (
        <div className="app">
            <div className="app-container container-fluid mb-5" style={{maxWidth: 'var(--breakpoint-xl)'}}>
                <div id="app-shadow"></div>
                <div className="app-container-inner">
                    <Row>
                        <Col className="d-flex justify-content-start" >
                            <div className="cursor-pointer" onClick={()=>reduxDispatch(push("/"))} >
                                <LogoWs style={{maxHeight: 50, width: 50}} />
                            </div>
                            <Col className="d-flex align-items-center"><h3 className="m-0">API Documentation</h3></Col>
                        </Col>
                        <Col xs="auto" className="d-flex justify-content-end">
                            <KeyMenu />
                        </Col>
                    </Row>
                    <Switch>
                        {
                            apiAccess.find(e => e.name === 'ivarwebapi') &&
                            <Route exact path="/ivarwebapi" render={ ()=><ApiPage />} />
                        }
                        <Route path="/" render={ ()=><WelcomePage />} />
                    </Switch>
                </div>
            </div>
        </div>
    )
}

export default App